import * as React from "react";

import { cn } from "../../lib/utils";

const Input = React.forwardRef(
  ({ className, type, readonly = false, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border-input bg-lightGray px-3 py-2 text-sm ring-offset-background text-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-white/50 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        readOnly={readonly}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
